
export default {
  data() {
    return {
      mode: 0
    };
  }
};
